import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AnimatePresenceWrapper } from "../../Utils";

class SlideInContent extends React.Component {

    state = {};

    constructor(props){
      
        super(props);

        this.className = props.className;
        this.animatedContent = props.children;
        this.state.isVisible = ((props.defaultVisible) ? props.defaultVisible : false); 
        this.addAnimatePresenceWrapper = (props.addAnimatePresenceWrapper) ? props.addAnimatePresenceWrapper :  true;
    }

    setVisible(set_to)
    {
        this.setState({isVisible:set_to});
    }

    render_motion()
    {
        return;
    }

    render(){

        return <AnimatePresence> {(this.state.isVisible) ?
            <motion.div 
                initial={{ opacity: 0, x: "-100%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: "-100%" }}
                transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                className={this.className}>
                {this.animatedContent}
            </motion.div> 
            : ''}</AnimatePresence>

        /*return (
            (this.addAnimatePresenceWrapper) ? <AnimatePresence>{this.render_motion()}</AnimatePresence> : <>{this.render_motion()}</>
        );*/
    }
    
};

export default SlideInContent;
